export default {
  order: {},
  orders: [],
  scheduledOrder: {},
  products: [],
  scheduledOrders: [],
  serviceTitanPendingOrders: []
}
